import { createStore, applyMiddleware } from 'redux'
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger'
import { composeWithDevTools } from 'redux-devtools-extension';

export default function configureStore() {
  let store = null;
  if (process.env.NODE_ENV === 'development') {
    store = createStore(
      rootReducer,
      composeWithDevTools(
        applyMiddleware(
          thunk,
          createLogger()
        ),
      )
    );
  } else if (process.env.NODE_ENV === 'production') {
    store = createStore(
        rootReducer,
        applyMiddleware(thunk)
    );
  }
  return store;
}



// WEBPACK FOOTER //
// ./src/store.js